import { FC } from 'react';
import ManageTokens from 'components/elements/components/ManageTokens';

const Screen: FC = () => {
  return (
    <ManageTokens
      elementsEntityName="client-element-tokens"
      elementsEndpoint="client-tokens"
      fieldsEntityName="client-fields"
      fieldsEndpoint="client-fields"
      tokenIdKey="client_token_id"
      fieldIdKey="client_field_id"
      elementFilter="client_element_id"
    />
  );
};

export default Screen;
